



let openFilterIntervalId;

function checkElement() {
  var element = $('#gf-open-filter');
  if (!element.length) return;
  if (!$._data(element.get(0), 'events')?.click) {
    element.on('click', function(event) {
      event.stopPropagation(); 
      $('.gf-filter-contents').slideToggle('fast');
      $('#gf-tree').toggleClass('filters-active');
    });
  }
 $(document).on('click', function(event) {
    var target = $(event.target);
    if (!target.closest('.gf-filter-contents').length && !target.is('#gf-open-filter')) {
      if ($('.gf-filter-contents').is(':visible')) {
        $('.gf-filter-contents').slideUp('fast');
        $('#gf-tree').removeClass('filters-active');
      }
    }
  });
}
$(document).ready(function() {
  checkElement();
});




function openFilterFunc() {
  openFilterIntervalId = setInterval(checkElement, 100);
}

window.addEventListener('globoFilterRenderCompleted', function () {
  openFilterFunc();
  setTimeout(function() {
    clearInterval(openFilterIntervalId);
  }, 500);
});